module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("I believe there is a wheel of life; a sort of labyrinth or maze-looking thing that has opening and closing gates at various intervals in life. Each of us circles around in this labyrinth at different speeds, and if we are lucky, or prepared, we find an opening that leads to another level. A level with more and perhaps greater life opportunities and understanding. Some people find more openings than others. Some fail to recognize the ones they do find. Regardless, the cycle continues throughout life. Once through a gate, you can never go back.")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("– Mark Brooks")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39322c3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 72
// module chunks = 0